import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export interface StoreReassignedResult {
  storeName: string;
  operatorName: string;
}

/** Owned by the page so refreshing/removing the old store card cannot dismiss it. */
export function StoreReassignedModal({ result, onClose }: {
  result: StoreReassignedResult | null;
  onClose: () => void;
}) {
  return (
    <AlertDialog open={result !== null} onOpenChange={(open) => { if (!open) onClose(); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Store successfully reassigned</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p><strong>{result?.storeName}</strong> has been reassigned to <strong>{result?.operatorName}</strong>.</p>
              <p>The work has been sent automatically. You do not need to send it again.</p>
              <p>Both operators’ task lists will update when their phones next sync.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onClose}>Done</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
